import React from 'react';

import WsIconProps from './IconProps';

const Mapping: React.FC<WsIconProps> = ({
  color = '#F2FBFD',
  color2 = '#F8D372',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
      fill={color}
    />
    <circle cx="11.9228" cy="8.48296" r="3.23296" fill="#F8D372" />
    <path
      d="M17.0955 17.535C17.0955 16.1632 16.5505 14.8474 15.5804 13.8774C14.6103 12.9073 13.2946 12.3623 11.9227 12.3623C10.5508 12.3623 9.23514 12.9073 8.26506 13.8774C7.29498 14.8474 6.75 16.1631 6.75 17.535L11.9227 17.535H17.0955Z"
      fill={color2}
    />
    <path
      d="M15.479 11.7158L16.9612 13.8786L19.4761 14.6199L17.8773 16.6979L17.9493 19.3189L15.479 18.4404L13.0086 19.3189L13.0807 16.6979L11.4818 14.6199L13.9967 13.8786L15.479 11.7158Z"
      fill={color2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9612 13.8786L15.479 11.7158L13.9967 13.8786L11.4818 14.6199L13.0807 16.6979L13.0086 19.3189L15.479 18.4404L17.9493 19.3189L17.8773 16.6979L19.4761 14.6199L16.9612 13.8786ZM18.3883 14.9734L16.5578 14.4338L15.479 12.8596L14.4001 14.4338L12.5696 14.9734L13.7333 16.4859L13.6809 18.3935L15.479 17.7541L17.277 18.3935L17.2246 16.4859L18.3883 14.9734Z"
      fill={color}
    />
  </svg>
);

export default Mapping;
